<template>
  <div>
    <cdr-grid class="course-hero">
      <div
        class="course-hero__img"
        data-ui="course-hero-img"
      >
        <cdr-img :src="baseImageUri" />
      </div>
      <div class="course-hero__meta">
        <ul
          v-if="courseAttributes.length > 0"
          class="course-attributes"
        >
          <li
            v-for="{ type, level, heading, subheading, tip } in courseAttributes"
            :key="type"
            :data-ui="`${type}-attribute`"
            class="course-attributes__item"
          >
            <div class="course-attributes__heading-container">
              <span class="course-attributes__heading">{{ heading }}</span>
              <span
                v-if="tip"
                class="course-attributes__level"
                data-ui="course-level-value"
              >
                {{ `: ${level}` }}
              </span>
              <cdr-button
                v-if="tip"
                :aria-label="`More information about ${heading}`"
                :data-type="type"
                :data-ui="`${type}-modal-trigger`"
                :icon-only="true"
                class="course-attributes__modal-trigger"
                aria-haspopup="dialog"
                @click="(event) => openModal({ event, type })"
              >
                <template #icon>
                  <icon-information-fill
                    size="small"
                    aria-hidden="true"
                    class="course-attributes__info-icon"
                  />
                </template>
              </cdr-button>
            </div>
            <cdr-text class="course-attributes__subheading">
              {{ subheading }}
            </cdr-text>
          </li>
        </ul>
        <div class="course-hero__description">
          <cdr-text
            class="course-hero__description-text"
            data-ui="course-description"
          >
            {{ longDescription }}
          </cdr-text>
        </div>
      </div>
    </cdr-grid>
    <cdr-modal
      id="attribute-modal"
      :opened="isModalOpen"
      :label="activeTitle"
      :aria-described-by="`${activeType}-description`"
      data-ui="attribute-modal"
      @closed="closeModal"
    >
      <template #title>
        <cdr-text
          tag="h3"
          class="course-hero__title"
        >
          {{ activeTitle }}
        </cdr-text>
      </template>
      <attribute-info-modal-content-component
        v-if="isModalOpen"
        v-bind="activeConfig"
      />
    </cdr-modal>
  </div>
</template>

<script>
import { CdrButton, CdrGrid, CdrImg, CdrModal, CdrText, IconInformationFill } from '@rei/cedar';
import AttributeInfoModalContentComponent from './AttributeInfoModalContentComponent.vue';
import constants from '../common/constants';
import metrics from '../mixins/metrics';

export default {
  name: 'CourseHeroComponent',
  components: {
    CdrButton,
    CdrGrid,
    CdrImg,
    CdrModal,
    CdrText,
    AttributeInfoModalContentComponent,
    IconInformationFill,
  },
  mixins: [metrics],
  props: {
    activityLevel: {
      type: [Boolean, Object],
      required: true,
      default: false,
    },
    allActivityLevels: {
      type: Array,
      required: true,
    },
    allSkillLevels: {
      type: Array,
      required: true,
    },
    baseImageUri: {
      type: String,
      required: true,
    },
    courseAttributes: {
      type: Array,
      required: true,
    },
    courseName: {
      type: String,
      required: true,
    },
    longDescription: {
      type: String,
      required: true,
    },
    skillLevel: {
      type: [Boolean, Object],
      required: true,
      default: false,
    },
  },
  data: () => ({
    activeType: '',
    isModalOpen: false,
  }),
  computed: {
    activeConfig() {
      const {
        activeType: type,
        activityLevel,
        allActivityLevels,
        allSkillLevels,
        courseName,
        skillLevel,
      } = this;
      if (!type) return {};
      const config = { courseName, type };
      switch (type) {
        case 'skill-level':
          config.activePayload = skillLevel;
          config.allLevels = allSkillLevels;
          config.blurb = constants.ATTRIBUTE_LEVELS.SKILL.BLURB;
          config.title = constants.ATTRIBUTE_LEVELS.SKILL.TITLE;
          break;
        case 'activity-level':
          config.activePayload = activityLevel;
          config.allLevels = allActivityLevels;
          config.title = constants.ATTRIBUTE_LEVELS.ACTIVITY.TITLE;
          break;
        default:
          break;
      }
      return config;
    },
    activeTitle() {
      const { title = '' } = this.activeConfig || {};
      return title;
    },
  },
  methods: {
    openModal({ type }) {
      this.activeType = type;
      const linkName = `{{ pageName }}_${type.replace('-', ' ')} modal_open`;
      this.metricsClick({ linkName });
      this.$nextTick(() => {
        this.isModalOpen = true;
      });
    },
    closeModal() {
      const { activeType: type } = this;
      this.isModalOpen = false;
      const linkName = `{{ pageName }}_${type.replace('-', ' ')} modal_close`;
      this.metricsClick({ linkName });
      this.$nextTick(() => {
        this.activeType = '';
      });
    },
  },
};
</script>
